import { TFunction } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { BannerNotification, Heading } from '@frontend/design-system';

interface NoInsuranceAccessProps {
  message: string;
  t: TFunction;
}

const NoInsuranceAccess = ({ message, t }: NoInsuranceAccessProps) => {
  return (
    <section css={{ padding: theme.spacing(2, 2, 1) }}>
      <header css={{ display: 'flex', justifyContent: 'space-between', marginBottom: theme.spacing(2) }}>
        <Heading level={3}>{t('Insurance')}</Heading>
      </header>
      <div css={{ margin: theme.spacing(2, 0) }}>
        <BannerNotification status='warn' message={message} />
      </div>
    </section>
  );
};
NoInsuranceAccess.displayName = 'NoInsuranceAccess';
export default NoInsuranceAccess;
